export default {
  loginMonitorApi: {
    getLawyerStatus: 'api/loginMonitor/getLawyerStatus',
    getOperationTypeLog: 'api/loginMonitor/getOperationTypeLog',
    exportOperationTypeLog: 'api/loginMonitor/exportOperationTypeLog',
    getUserLog: 'api/loginMonitor/getUserLog'
  }
}